export const resolveActiveDevice = (
    devices: Pick<MediaDeviceInfo, 'deviceId'>[],
    selectedDeviceId: string | null | undefined,
): string | undefined =>
    (devices.find(device => device.deviceId === selectedDeviceId)
        ?? devices.find(device => device.deviceId === 'default')
        ?? devices[0])?.deviceId;
